import RequestManager from "./RequestManager";

const getAllSessionsInDomain = async (domainId, firstCursor, lastCursor, prev, getLatest) => {
    const queryParams = ["?ascending=false"];
    if (prev) {
        queryParams.push("cursor=" + firstCursor, "prev=true");
    }
    else if (lastCursor) {
        queryParams.push("cursor=" + lastCursor);
    }
    
    if (getLatest) {
        queryParams.push("getLatest=true");
    }
    const urlParams = queryParams.join('&');

    const sessions = await RequestManager.get({
        url: "/audit/session/domain/v1/" + domainId + urlParams
    });
    return sessions.data;
};

const getAuditTrailForASession = async (sessionId) => {
    const auditTrail = await RequestManager.get({
        url: "/audit/session/v1/" + sessionId
    });
    return auditTrail;
};

const AuditTrail = {
    getAllSessionsInDomain,
    getAuditTrailForASession
};

export default AuditTrail;